RivalIQ.apps.LandscapeSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.General = Marionette.ItemView.extend({
        ui: {
            save: '.x-landscape-admin',
            auditable: 'input[name="auditable"]',
            timezone: '.x-timezone-str',
            deleteMsg: '.disable-msg'
        },

        events: {
            'click .x-change-timezone': 'onChangeTimezoneClicked',
            'click .x-landscape-admin': 'onSaveClicked',
            'click .x-rename': 'onRenameClick',
            'click .x-share': 'onShareClick',
            'click .x-duplicate': 'onDuplicateClick',
            'click .x-landscape-id': 'onLandscapeIdClick',
            'click .x-delete': 'onDeleteClick'
        },

        template: '#landscapeChannelsTemplate',

        templateHelpers: function () {
            const plan = RivalIQ.state.account.get('plan');
            return {
                hasAnyApiAccess: (plan.has_api_access || plan.has_gds_connector),
                landscapeId: RivalIQ.state.landscape.get('id')
            };
        },

        userHasSingleLandscape: function () {
            const landscapes = RivalIQ.state.user.get('landscapes') || [];
            return landscapes.length === 1;
        },

        serializeData: function () {
            const me = this;
            const timezone = RivalIQ.state.landscape.get('timezone');
            return {
                timezoneStr: RivalIQ.utils.timezone.getDisplayName(timezone),
                disableDelete: me.userHasSingleLandscape()
            };
        },

        onRender: function () {
            const me = this;

            if (me.userHasSingleLandscape()) {
                me.ui.deleteMsg.popover();
            }
        },

        onBeforeShow: function () {

            const me = this;
            const landscape = RivalIQ.state.landscape;
            me.ui.auditable.prop('checked', landscape.get('isCompanyAuditable'));
        },

        onSaveClicked: function () {

            const me = this;
            const isCompanyAuditable = me.ui.auditable.is(':checked');

            RivalIQ.state.landscape.set({
                isCompanyAuditable: isCompanyAuditable
            });
        },

        onChangeTimezoneClicked: function () {
            const me = this;

            RivalIQ.execute('show:modal', new RivalIQ.apps.LandscapeSettings.views.TimezonePicker({
                model: RivalIQ.state.landscape,
                onSaved: function () {
                    const timezone = RivalIQ.state.landscape.get('timezone');
                    me.ui.timezone.text(RivalIQ.utils.timezone.getDisplayName(timezone));

                    RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SetInsightsTimeZone, {
                        timezone: timezone
                    });
                }
            }));
        },

        onRenameClick: function () {
            RivalIQ.execute('show:modal', new App.views.RenamingModal({
                model: RivalIQ.state.view
            }));
        },
        onShareClick: function () {
            RivalIQ.execute('show:modal', new RivalIQ.views.ShareLandscapeModal({
                model: new Backbone.Model({
                    name: RivalIQ.state.view.get('landscapeName'),
                    url: RivalIQ.state.landscape.get('cloneUrl')
                })
            }));
        },
        onDuplicateClick: function () {
            RivalIQ.execute('show:modal', new App.views.Duplicate({
                model: new Backbone.Model({
                    id: RivalIQ.state.view.get('landscapeId')
                })
            }));
        },
        onLandscapeIdClick: function () {
            RivalIQ.execute('show:modal', new Marionette.ItemView({
                template: '#getLandscapeIDTemplate'
            }));
        },
        onDeleteClick: function () {
            const landscapeId = RivalIQ.state.view.get('landscapeId');
            const landscapeName = RivalIQ.state.view.get('landscapeName');
            const view = new App.views.Delete({
                model: new RivalIQ.models.Landscape({
                    id: landscapeId,
                    name: landscapeName
                })
            });

            RivalIQ.execute('show:modal', view);
        }
    });

});
